export default __webpack_public_path__ + "static/media/skilift.04dcfd61.jpg";